import { HStack, VStack } from '@rbilabs/universal-components';

import { theme } from 'styles/configure-theme';

export const ItemRow = HStack.withConfig(({ isLastItem }: { isLastItem: boolean }) => ({
  borderBottomWidth: isLastItem ? 0 : 1,
  borderColor: theme.token('border-color-options'),
}));

export const AddExtrasDebugMenuContainer = VStack.withConfig({
  backgroundColor: theme.token('icon-button-primary'),
});
